import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import FormDialog from './FormDialog';
import FormDialogFooter from './FormDialogFooter';
import FormDialogAppBar from './FormDialogAppBar';
import FormSection, { FormSectionsBody } from './FormSection';

/**
 * The fullscreen record dialog's chrome shown WHILE its record loads from the
 * local DB. Mirrors the real editor — the app bar, the canvas with a section
 * "box", and the sticky Save/Cancel footer — but the box holds Skeletons and
 * Save is disabled. The routes render this instead of `null`, so the dialog
 * appears instantly and swaps to the filled form when the record arrives (no
 * fade — see FormDialog).
 */
export default function FormDialogShell({
    projectId,
    titleId,
    onClose
}: {
    projectId: string;
    /** The record type's edit title, e.g. "planum.form.editTitle". */
    titleId: string;
    onClose: () => void;
}) {
    return (
        <FormDialog open onClose={onClose} fullScreen>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}
            >
                <FormDialogAppBar
                    projectId={projectId}
                    onClose={onClose}
                    title={<FormattedMessage id={titleId} />}
                />

                <FormSectionsBody>
                    <FormSection>
                        <Skeleton variant="text" width="40%" height={32} />
                        <Skeleton variant="rounded" height={56} />
                        <Skeleton variant="rounded" height={56} />
                        <Skeleton variant="rounded" width="70%" height={56} />
                    </FormSection>
                </FormSectionsBody>

                {/* The real dialog's footer, so the swap doesn't shift it:
                    Save is inert while the record loads, Cancel already works. */}
                <FormDialogFooter
                    onCancel={onClose}
                    isSubmitting={false}
                    saveDisabled
                />
            </Box>
        </FormDialog>
    );
}
